import { useQuery } from '@tanstack/react-query';

import AccountUserApi from '../../../../../lib/api/account/user/AccountUserApi';
import { setRequestForm } from '../../../../../lib/common';
import { accountUserDetailKey } from '../common/queryKeys';
import { ACCOUNT_USER_CART_DETAIL_MODEL } from './models';

export const useAccountUserCartDetailQuery = ({ userId, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'userCart', 'detail', userId],
    async () => {
      const result = await AccountUserApi.getAccountUserCartDetail(
        setRequestForm(
          {
            userId,
          },
          true,
        ),
      );

      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: () => ({
        data: {
          cartSummaryData: ACCOUNT_USER_CART_DETAIL_MODEL,
          cartHistoryList: { list: [] },
        },
      }),
    },
  );
};

export const useAccountUserDetailCartLogModalQuery = ({ userId, filterOption, sortOption, options }) => {
  return useQuery(
    [...accountUserDetailKey, 'visitorLog', userId, filterOption, sortOption],
    async () => {
      const result = await AccountUserApi.getAccountUserDetailCartLogList(
        setRequestForm(
          {
            userId,
            cartLogHistory: {
              filterOption,
              sortOption,
            },
          },
          true,
        ),
      );

      if (result.msg) throw new Error(result.msg);
      return result;
    },
    {
      ...options,
      initialData: { data: { userCartLogList: [] } },
    },
  );
};
